export const QUESTION_TYPES = {
    TEST_STORE: 'QUESTIONS/TEST_STORE',
    UPDATE_LIST: 'QUESTIONS/UPDATE_LIST',
    UPDATE_INDEX: 'QUESTIONS/UPDATE_INDEX',
    UPDATE_ANSWERS: 'QUESTIONS/UPDATE_ANSWERS',
    UPDATE_CONF: 'QUESTIONS/UPDATE_CONF',
};
